import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchFormBaseComponent } from './e5core-ui-search-form-base';

@Component({
  selector: 'e5core-ui-search-form-box',
  templateUrl: './e5core-ui-search-form-box.component.html',
  styleUrls: ['./e5core-ui-search-form-box.component.css']
})
export class E5coreUiSearchFormBoxComponent extends E5coreUiSearchFormBaseComponent implements OnInit {

  ngOnInit() {
  }

}

